import React from 'react'
import {motion} from 'motion/react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'

import {BaseHomeDesktopHeader} from './BaseHomeDesktopHeader'
import {BaseHomeMobileHeader} from './BaseHomeMobileHeader'
import {SearchBoxShadow} from './SearchBoxShadow'

interface Props {
  isVisible?: boolean
}
export const FixedHeader: React.FC<Props> = ({isVisible}) => {
  const {isMobile, isDesktopLg} = useDeviceLayout()

  if (isMobile) return null

  return (
    <>
      <motion.div
        style={{
          position: 'fixed',
          width: '100%',
          zIndex: '4'
        }}
        initial={false}
        animate={{
          y: isVisible ? 0 : -170
        }}
        transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }}
      >
        {isMobile ? (
          <BaseHomeMobileHeader
            hasHeaderSearchSummary={true}
            hasDivider={true}
          />
        ) : (
          <BaseHomeDesktopHeader
            withSearchForm
            showSupportButton={isDesktopLg}
            isStatic={false}
          />
        )}
      </motion.div>

      {isMobile && <SearchBoxShadow />}
    </>
  )
}
